export const COMPANIES = ['JAVERIANA', 'SOACHA-BAN', 'SOACHA-DAV']